import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

// Shared layout for /impressum, /datenschutz, /agb (ticket #559)
// Top-Nav (D-00) + Footer (D-07) - kept simple here so the landing-page
// agent can drop in the real components later without conflicts.

const LegalLayout = ({ title, children }) => {
  return (
    <div
      className="min-h-screen flex flex-col bg-white text-gray-900"
      style={{ fontFamily: "Plus Jakarta Sans, sans-serif" }}
    >
      <TopNav />
      <main className="flex-1">
        <div className="mx-auto w-full max-w-3xl px-6 py-12 sm:py-16">
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">
            {title}
          </h1>
<div className="prose prose-gray max-w-none text-gray-800 leading-relaxed">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

const LegalLanguageToggle = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <div className="flex items-center gap-1" aria-label="Language switcher">
      <button
        type="button"
        onClick={() => setLanguage("en")}
        aria-pressed={language === "en"}
        className={`text-xs font-semibold px-2 py-1 rounded transition-colors ${
          language === "en" ? "text-[#6A0DAD]" : "text-gray-400 hover:text-gray-600"
        }`}
      >
        EN
      </button>
      <span className="text-gray-300" aria-hidden="true">/</span>
      <button
        type="button"
        onClick={() => setLanguage("de")}
        aria-pressed={language === "de"}
        className={`text-xs font-semibold px-2 py-1 rounded transition-colors ${
          language === "de" ? "text-[#6A0DAD]" : "text-gray-400 hover:text-gray-600"
        }`}
      >
        DE
      </button>
    </div>
  );
};

const TopNav = () => {
  const { t } = useLanguage();
  return (
  <header className="border-b border-gray-100 bg-white/80 backdrop-blur sticky top-0 z-30">
    <div className="mx-auto max-w-6xl px-6 h-16 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 200 60"
          className="h-8 w-auto"
          aria-label="Reflecta"
          role="img"
        >
          <defs>
            <linearGradient id="reflectaLegalGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#9B30FF" />
              <stop offset="100%" stopColor="#6A0DAD" />
            </linearGradient>
          </defs>
          <rect x="10" y="10" width="40" height="40" rx="10" ry="10" fill="url(#reflectaLegalGradient)" />
          <line x1="30" y1="10" x2="30" y2="50" stroke="#FFFFFF" strokeWidth="1.5" />
          <path d="M20 25 Q 25 18, 30 25 Q 35 32, 40 25" stroke="#FFFFFF" strokeWidth="2" fill="none" />
          <path d="M20 35 Q 25 42, 30 35 Q 35 28, 40 35" stroke="#FFFFFF" strokeWidth="2" fill="none" opacity="0.7" />
          <text x="60" y="38" fontFamily="'Plus Jakarta Sans', system-ui, sans-serif" fontWeight="600" fontSize="24" fill="#171717">Reflecta</text>
        </svg>
      </Link>
      <nav className="flex items-center gap-5 text-sm">
        <LegalLanguageToggle />
        <Link to="/" className="text-gray-700 hover:text-purple-700">
          {t("legal.backHome")}
        </Link>
        <Link
          to="/auth"
          className="rounded-xl px-4 py-2 text-sm font-medium text-white"
          style={{
            background: "linear-gradient(135deg, #9B30FF 0%, #6A0DAD 100%)",
          }}
        >
          {t("auth.login")}
        </Link>
      </nav>
    </div>
  </header>
  );
};

const Footer = () => {
  const { t } = useLanguage();
  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent("open-cookie-settings"));
  };
  return (
    <footer className="border-t border-gray-100 bg-gray-50">
      <div className="mx-auto max-w-6xl px-6 py-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-gray-600">{t("landing.footer.copyright")}</p>
        <nav className="flex flex-wrap gap-x-5 gap-y-3 text-sm">
          <Link to="/impressum" className="text-gray-700 hover:text-purple-700 inline-block py-2 px-1">
            {t("landing.footer.impressum")}
          </Link>
          <Link
            to="/datenschutz"
            className="text-gray-700 hover:text-purple-700 inline-block py-2 px-1"
          >
            {t("landing.footer.datenschutz")}
          </Link>
          <Link to="/agb" className="text-gray-700 hover:text-purple-700 inline-block py-2 px-1">
            {t("landing.footer.agb")}
          </Link>
          <button
            type="button"
            onClick={openCookieSettings}
            className="text-gray-700 hover:text-purple-700 inline-block py-2 px-1"
          >
            {t("landing.footer.cookieSettings")}
          </button>
        </nav>
      </div>
    </footer>
  );
};

export default LegalLayout;
